<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row class="mb-3">
        <v-col cols="12" md="4">
          <DateIOSPicker label="Ngày" :date.sync="time" outlined :rules="[$rules.date, $rules.dateFromNow]" dense />
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="status"
            :items="attendanceStatus"
            item-text="title"
            item-value="status"
            label="Trạng thái"
            dense
            outlined
            clearable
            hide-details
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <GradeClassStudentSelect @changed="gradeClassStudentChange" />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="handleSearch" outlined> Tìm kiếm </v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapMutations, mapState } from 'vuex'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'

export default {
  components: { DateIOSPicker, GradeClassStudentSelect },
  data() {
    return {
      selectedGrade: {},
      selectedClass: {},
      selectedStudent: {},
      status: '',
      time: moment().toISOString(),
    }
  },
  computed: {
    ...mapState('constant', ['attendanceStatus']),
    ...mapState('lessonAttendance', ['page', 'itemPerPage']),
  },
  methods: {
    ...mapActions({
      fetchAttendances: 'lessonAttendance/fetchAttendances',
      countAttendances: 'lessonAttendance/countAttendances',
    }),
    ...mapMutations({
      setFiltered: 'lessonAttendance/setFiltered',
      setLoading: 'lessonAttendance/setLoading',
      setSearchQuery: 'lessonAttendance/setSearchQuery',
      setPage: 'lessonAttendance/setPage',
      setItemPerPage: 'lessonAttendance/setItemPerPage',
    }),
    gradeClassStudentChange(data) {
      this.selectedGrade = data.grade
      this.selectedClass = data.class
      this.selectedStudent = data.student
    },
    getDayStartEnd(isoString) {
      const date = moment(isoString)

      const startOfDay = date.startOf('day').toISOString()
      const endOfDay = date.endOf('day').toISOString()

      return {
        startOfDay,
        endOfDay,
      }
    },

    handleSearch() {
      this.setLoading(true)
      const { startOfDay, endOfDay } = this.getDayStartEnd(this.time)
      const params = {
        date_gte: startOfDay,
        date_lte: endOfDay,
      }
      if (this.status) params.status = this.status
      if (this.selectedGrade.id) params.grade = this.selectedGrade.id
      if (this.selectedClass.id) params.class = this.selectedClass.id
      if (this.selectedStudent.id) params.student = this.selectedStudent.id
      this.setFiltered(true)
      this.setLoading(false)
      this.setSearchQuery(params)
      this.$emit('search')
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
